import { Box } from "@dropbox/dig-foundations";
import { useCallback, useEffect } from "react";

export const ChartCard = ({
  open,
  isFocus,
  children,
  expanded,
  onClose,
}: {
  open: boolean;
  isFocus: boolean;
  children: React.ReactNode;
  expanded: boolean;
  onClose: () => void;
}) => {
  useEffect(() => {
    if (!expanded) {
      onClose();
    }
  }, [expanded, onClose]);

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        if (open && !isFocus) {
          event.preventDefault();
          event.stopPropagation();
        }
        onClose();
      }
    },
    [open, isFocus, onClose],
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleKeyDown]);

  if (!expanded) {
    return null;
  }

  return (
    <>
      <Box
        position="absolute"
        display="flex"
        style={{
          bottom: 16,
          right: 16,
          maxHeight: "calc(100% - 84px)",
          opacity: open ? 1 : 0,
          transform: `translateX(${open ? 0 : 500}px)`,
          transition: open
            ? `transform var(--easing__enter) var(--duration__125), opacity ease var(--duration__surface)`
            : "none",
        }}
      >
        {children}
      </Box>
    </>
  );
};
